module.exports = __webpack_public_path__ + "static/media/iconCourses.8f534617.svg";